module.exports = __webpack_public_path__ + "static/media/za.9b853c8e.svg";